import { getCommonPrintTypes } from '@/model/configuration/getCommonPrintTypes';
import { getAppearance } from '@/model/draft/getAppearance';
import { getConfigurationsForPrintTypeAlignment } from '@/model/draft/getConfigurationsForPrintTypeAlignment';
import { getSelectedConfiguration } from '@/model/draft/getSelectedConfiguration';
import { StoreState } from '@/redux/types';
import { getDraft } from './getDraft';

// to avoid mixed print types on a print area filter down
//  to the print types that are supported by all configurations
export function possiblePrintTypesForSelectedConfiguration(state: StoreState) {
  const draft = getDraft(state);
  const currentConfiguration = getSelectedConfiguration(draft);
  const [otherConfigurations] = getConfigurationsForPrintTypeAlignment(draft, currentConfiguration);
  return getCommonPrintTypes([currentConfiguration, ...otherConfigurations], getAppearance(draft));
}
